import React from 'react';
import { TextField } from '@mui/material';
import { formatDay, formatMoment, toInputMoment } from './revenueEntryCalc';
import type { EntryBounds, EntryKind } from './revenueEntryApi';

/** Срок правила: поле datetime-local по времени Алматы, не позже чем через 24 часа */
export const UntilField: React.FC<{
  value: string;
  onChange: (value: string) => void;
  bounds: EntryBounds;
  kind: EntryKind;
  error: string;
  disabled?: boolean;
}> = ({ value, onChange, bounds, kind, error, disabled }) => (
  <TextField
    size="small"
    fullWidth
    required
    type="datetime-local"
    label="Действует до"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    disabled={disabled}
    error={!!error}
    helperText={error || `Не дольше 24 часов: не позже ${formatMoment(bounds.maxUntil)}`}
    InputLabelProps={{ shrink: true }}
    inputProps={{
      min: toInputMoment(kind === 'extend' ? bounds.extendAfter : bounds.now),
      max: toInputMoment(bounds.maxUntil),
      step: 60
    }}
  />
);

/** Дата ввода: за последние 6 месяцев, не позже сегодня */
export const EntryDateField: React.FC<{
  value: string;
  onChange: (value: string) => void;
  bounds: EntryBounds;
  error: string;
  disabled?: boolean;
}> = ({ value, onChange, bounds, error, disabled }) => (
  <TextField
    size="small"
    fullWidth
    required
    type="date"
    label="Дата ввода"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    disabled={disabled}
    error={!!error}
    helperText={error || `С ${formatDay(bounds.minDate)} по ${formatDay(bounds.maxDate)}`}
    InputLabelProps={{ shrink: true }}
    inputProps={{ min: bounds.minDate, max: bounds.maxDate }}
  />
);
